import React, { useContext } from 'react';
import ColumnChart from 'components/columnChart/columnChart';
import { observer } from 'mobx-react-lite';
import { MobxContext } from 'mobx/mobxContext';
import { Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactDOMServer from 'react-dom/server';
import RegularTooltip from 'components/tooltips/regularTooltip';
import { SpecialDepartments } from 'mobx/storeTypes';

export default observer(function AllDepartmentsChart() {
  const {
    mobxStore: { allDepartmentsStore, departmentStore },
  } = useContext(MobxContext);

  const { allDepartmentsAdaptedData } = allDepartmentsStore;

  const navigate = useNavigate();
  const location = useLocation();

  const formatterFn: Highcharts.TooltipFormatterCallbackFunction = function () {
    const datePeriod = this.series.name;

    return ReactDOMServer.renderToString(<RegularTooltip date={datePeriod} />);
  };

  const handleRootPath = function (e: Highcharts.SeriesClickEventObject) {
    if (location.pathname === '/') {
      const options = e.point.options as any;
      const departmentId = options.department_id;
      // Костыль
      const departmentName =
        departmentId === SpecialDepartments.DEPUTIES
          ? ''
          : options.department_name;

      departmentStore.fetchDepartmentData(departmentId, departmentName);
      navigate(`/department/${departmentStore.currentDepartmentId}`);
    }
  };

  if (!allDepartmentsAdaptedData?.series) {
    return null;
  }

  return (
    <Box>
      <ColumnChart
        chartData={allDepartmentsAdaptedData}
        plotOptionsArgs={{
          handleClick: handleRootPath,
          cursor: 'pointer',
        }}
        tooltipOptionsArgs={{
          formatter: formatterFn,
          outside: false,
          padding: 8,
        }}
      />
    </Box>
  );
});
